import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { updateAssetVisibility } from '@api/assetVisibility';

import { IUpdateAssetVisibilityDTO } from '@interfaces/assets/dto/assetVisibilityDTO';

import { EUserRoles } from '@enums/common';

import {
	ASSET_VISIBILITY,
	ASSET_VISIBILITY_RESTRICTED,
	ASSET_VISIBILITY_UPDATE,
} from '@constants/queryKeys';

interface IUseMutateUpdateAssetVisibilityReturned {
	updateAssetVisibility: UseMutateFunction<any, any, IUpdateAssetVisibilityDTO, any>;
	isLoadingUpdateAssetVisibility: boolean;
}

export const useMutateUpdateAssetVisibility = (): IUseMutateUpdateAssetVisibilityReturned => {
	const queryClient = useQueryClient();

	const {
		mutate,
		isLoading,
	} = useMutation<IUpdateAssetVisibilityDTO>({
		mutationKey: [ASSET_VISIBILITY_UPDATE],
		allowedRoles: [
			EUserRoles.platformOwnerAdministrator,
			EUserRoles.assetOwnerOrganizationAdministrator,
		],
		mutationFn: updateAssetVisibility,
		onSuccess: () => {
			return [
				queryClient.invalidateQueries([ASSET_VISIBILITY_RESTRICTED]),
				queryClient.invalidateQueries([ASSET_VISIBILITY]),
			];
		},
	});

	return {
		updateAssetVisibility: mutate,
		isLoadingUpdateAssetVisibility: isLoading,
	};
};
